import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  entries: {
    byId: {},
    allIds: [],
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isTranslating: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
